/**
 * @function
 * @param f: функция
 * @param p1: первый аргумент функции
 * @return функция, которая в момент вызова будет вести себя так,
 * как f(p1, ...args), т.е. с упрощённой сигнатурой
 * partial(f, ...p1)(...p2) --> f(...p1, ...p2)
 */
export function partial(f, ...p1) {
    // return (...p2: RestArgs<F, P1>): ReturnType<F> => f(...p1, ...p2);
    return f.bind(null, ...p1);
}
